const shared = {
  buttons: {
    bookNow: "Varaa aika",
    learnMore: "Lue lisää",
    sendMessage: "Lähetä viesti",
  },
  labels: {
    phone: "Puhelin",
    email: "Sähköposti",
    address: "Osoite",
  },
  meta: {
    siteTitle: "Eläinklinikka Aurinko",
    siteDescription: "Lempeää ja asiantuntevaa hoitoa lemmikeillesi",
  },
};

export default shared;
